import { render, staticRenderFns } from "./VirtualShopHome.vue?vue&type=template&id=2dec4fd2&scoped=true"
import script from "./VirtualShopHome.vue?vue&type=script&lang=ts"
export * from "./VirtualShopHome.vue?vue&type=script&lang=ts"
import style0 from "./VirtualShopHome.vue?vue&type=style&index=0&id=2dec4fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec4fd2",
  null
  
)

export default component.exports